"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import PostHogSessionReplayGate from "@/components/providers/PostHogSessionReplayGate";

// posthog is initialized via instrumentation-client.ts

export default function PostHogProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <PHProvider client={posthog}>
      <PostHogSessionReplayGate />
      {children}
    </PHProvider>
  );
}
